// extracted by mini-css-extract-plugin
export default {"home":"home_home__CL7uo","mainContent":"home_mainContent__Hw10Q"};